import React from 'react';
import { Button, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import AuthAddNewPopup from './AuthAddNewPopup';

const useStyles = makeStyles((theme) => ({
  imgStyles: {
    width: '475px',
    height: '300px',
  },
  addressHeading: {
    textAlign: 'left',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '17px',
    fontStyle: 'normal',
    color: 'rgba(0, 0, 0, 0.4)',
    marginBottom: 0,
  },
  addressText: {
    wordBreak: 'break-all',
    textAlign: 'left',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '21px',
    fontStyle: 'normal',
    color: 'black',
    marginTop: '5px',
  },
  container: {
    overflow: 'auto',
    width: '281px',
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },
  editStyle: {
    fontWeight: 400,
    fontSize: '14px',
    textDecoration: 'underline',
    '&:hover': {
      cursor: 'pointer',
      fontWeight: 600,
      color: theme.palette.primary.main,
    },
  },
  editButton: {
    height: '35px',
    marginRight: '10px',
  },
  editDiv: {
    marginTop: '20px',
  },
}));

const LeftbarAuthClient = () => {
  const classes = useStyles();
  const authclientdetails = useSelector((state) => state.getAuthClientDetails.authclientdetails);
  const [IsAddnewAuthPopupOpen, setisAddnewAuthPopupOpen] = React.useState(false);
  const closeAddNewAuth = () => {
    setisAddnewAuthPopupOpen(false);
  };

  return (
    <section>
      <Grid
        className={classes.container}
        container
        direction="column"
        justifyContent="flex-start"
        alignItems="flex-start"
      >
        <Grid item>
          <p className={classes.addressHeading}>AUTH NAME</p>
          <p className={classes.addressText}>{authclientdetails.name}</p>
        </Grid>
        <Grid item>
          <p className={classes.addressHeading}>AUTH TYPE</p>
          <p className={classes.addressText}>{authclientdetails.type}</p>
        </Grid>
        <Grid item>
          <p className={classes.addressHeading}>ENDPOINT URL</p>
          <p className={classes.addressText}>{authclientdetails.issuer}</p>
        </Grid>
        <Grid item>
          <p className={classes.addressHeading}>COMPANY CODE</p>
          <p className={classes.addressText}>{authclientdetails.companyCode}</p>
        </Grid>
        <Grid item>
          <p className={classes.addressHeading}>SCOPES</p>
          <p className={classes.addressText}>{authclientdetails.scopes}</p>
        </Grid>
      </Grid>
      <div className={classes.editDiv}>
        <Button
          variant="contained"
          color="primary"
          focusRipple={false}
          onClick={() => {
            setisAddnewAuthPopupOpen(!IsAddnewAuthPopupOpen);
          }}
          className={classes.editButton}
        >
          Edit
        </Button>
      </div>
      {IsAddnewAuthPopupOpen && <AuthAddNewPopup edit close={closeAddNewAuth} />}
    </section>
  );
};

export default LeftbarAuthClient;
